/** Companion section sports: chip label and the name used in copy. Shared by the server grid and the client island. */
export type CompanionSport = "ski" | "mtb" | "surf" | "other";

export const COMPANION_SPORTS: ReadonlyArray<{ key: CompanionSport; label: string; name: string }> = [
  { key: "ski", label: "Ski", name: "ski" },
  { key: "mtb", label: "MTB", name: "MTB" },
  { key: "surf", label: "Surf", name: "surf" },
  { key: "other", label: "Other sports", name: "other sports" },
];
